import { ManageBookingSteps, ManageBookingErrorSteps } from './interfaces/manage-booking-step.interface';

export const MANAGE_BOOKING_STEPS: ManageBookingSteps = {
  CHECK_IN: {
    path: 'check-in',
    data: {
      server: true,
    },
  },
  ENTRY: {
    path: '',
    data: {
      server: true,
    },
  },
  VIEW: {
    path: 'view',
  },
  VIEW_PASSENGERS: {
    path: 'view/passengers',
  },
  TRAVEL_PREPARATION: {
    path: 'view/travel-preparations',
  },
  REVIEW: {
    path: 'review',
  },
  CHECKOUT: {
    path: 'checkout',
  },
  CONFIRMATION: {
    path: 'confirmation',
  },
};

export const ERROR_STEPS: ManageBookingErrorSteps = {
  PAYMENT_ERROR: {
    path: 'payment/error',
  },
  ERROR: {
    path: 'error',
  },
  ERROR_ROUTE: {
    path: 'error/:error',
  },
};
